import { SearchX } from 'lucide-react';
import { Link } from 'react-router-dom';

type FeedEmptyStateProps = {
  title: string;
  description: string;
};

export function FeedEmptyState({ title, description }: FeedEmptyStateProps) {
  return (
    <div className="safe-px grid min-h-[55dvh] place-items-center text-center">
      <div>
        <SearchX className="mx-auto text-divergent-yellow" size={34} aria-hidden="true" />
        <h2 className="mt-4 text-2xl font-black">{title}</h2>
        <p className="mt-2 text-white/62">{description}</p>
        <Link
          to="/"
          className="mt-5 inline-flex min-h-10 items-center rounded bg-divergent-yellow px-4 text-sm font-semibold text-black"
        >
          Volver al feed
        </Link>
      </div>
    </div>
  );
}
